<template>
  <div>
    <v-container grid-list-md>
      <!-- ENCABEZADO -->
      <v-layout row wrap>
        <v-flex xs12>
          <h1>{{ $t('security_admin_dashboard') }}</h1>
          <p>{{ $t('security_admin_dashboard_welcome') }}</p>
        </v-flex>
      </v-layout>

      <!-- SECCIÓN 1: ESTADÍSTICAS/DASHBOARD -->
      <v-layout row wrap>
        <!-- Pending Contracts Alert Card -->
        <v-flex xs12 md3>
          <v-card
            :class="['elevation-6', pendingContractsCount > 0 ? 'pending-contracts-card' : 'primary']"
            style="cursor: pointer;"
            @click="$router.push('/security/pending-contracts')"
          >
            <v-card-text class="text-center white--text">
              <div style="position: relative; display: inline-block;">
                <v-icon size="48" color="white" :class="{ 'pulse-icon': pendingContractsCount > 0 }">
                  {{ pendingContractsCount > 0 ? 'notification_important' : 'schedule' }}
                </v-icon>
                <span
                  v-if="pendingContractsCount > 0"
                  style="position: absolute; top: -6px; right: -14px; background: #c62828; color: white; border-radius: 50%; width: 20px; height: 20px; font-size: 11px; font-weight: bold; display: flex; align-items: center; justify-content: center;"
                >
                  {{ pendingContractsCount }}
                </span>
              </div>
              <h3 class="mt-3 mb-0">{{ pendingContractsCount }}</h3>
              <p>Contratos Pendientes</p>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 md3>
          <v-card class="elevation-3">
            <v-card-text class="text-center">
              <v-icon size="48" color="primary">security</v-icon>
              <h3 class="mt-3 mb-0">{{ totalGuards }}</h3>
              <p>{{ $t('security_total_guards') }}</p>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 md3>
          <v-card class="elevation-3">
            <v-card-text class="text-center">
              <v-icon size="48" color="success">check_circle</v-icon>
              <h3 class="mt-3 mb-0 success--text">{{ activeGuards }}</h3>
              <p>{{ $t('security_guards_on_shift') }}</p>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 md3>
          <v-card class="elevation-3">
            <v-card-text class="text-center">
              <v-icon size="48" color="info">business</v-icon>
              <h3 class="mt-3 mb-0">{{ totalClients }}</h3>
              <p>{{ $t('security_total_clients') }}</p>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 md3>
          <v-card class="elevation-3" style="cursor:pointer;" @click="$router.push('/security/shift-history')">
            <v-card-text class="text-center">
              <v-icon size="48" color="blue-grey">history</v-icon>
              <h3 class="mt-3 mb-0">Historial</h3>
              <p>Turnos de Guardias</p>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 md3>
          <v-card class="elevation-3" style="cursor:pointer;" @click="$router.push('/security/my-parks')">
            <v-card-text class="text-center">
              <v-icon size="48" color="indigo">location_on</v-icon>
              <h3 class="mt-3 mb-0">{{ myParks.length }}</h3>
              <p>Parques Vinculados</p>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 md3 v-if="pendingParks > 0">
          <v-card class="elevation-3" style="cursor:pointer;" @click="$router.push('/security/my-parks')" :class="['pending-parks-card']">
            <v-card-text class="text-center white--text">
              <v-icon size="48" color="white">pending_actions</v-icon>
              <h3 class="mt-3 mb-0">{{ pendingParks }}</h3>
              <p>Parques Pendientes</p>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <!-- SECCIÓN 2: INFORMACIÓN DE LA EMPRESA Z Y CLIENTES ASIGNADOS -->
      <v-layout row wrap class="mt-4">
        <v-flex xs12 md6>
          <v-card class="elevation-3">
            <v-toolbar dark color="primary" class="mb-3">
              <v-toolbar-title>{{ $t('security_company_info_title') }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text>
              <v-progress-linear v-if="isLoading" indeterminate class="mb-3"></v-progress-linear>

              <v-list dense v-if="myCompany">
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ $t('security_company_name') }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ myCompany.company_name || 'N/A' }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider></v-divider>

                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ $t('security_company_id') }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ myCompany.company_id || 'N/A' }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider></v-divider>

                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ $t('security_total_active_guards') }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ myCompany.total_active_guards || 0 }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider></v-divider>

                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ $t('security_guards_on_shift') }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ myCompany.guards_on_shift || 0 }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 md6>
          <v-card class="elevation-3">
            <v-toolbar dark color="primary" class="mb-3">
              <v-toolbar-title>{{ $t('security_assigned_clients') }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text>
              <v-progress-linear v-if="isLoading" indeterminate class="mb-3"></v-progress-linear>

              <v-list dense v-if="assignedClients.length > 0">
                <v-list-tile v-for="client in assignedClients" :key="client.id">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ client.name || 'N/A' }}</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-chip small color="success" text-color="white">
                      {{ client.status_display || client.status }}
                    </v-chip>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
              <v-alert v-else-if="!isLoading" type="info" :value="true">
                Sin clientes asignados
              </v-alert>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import {
  FETCH_MY_COMPANY,
  FETCH_ADMIN_DASHBOARD,
  FETCH_GUARDS,
  FETCH_ACTIVE_SHIFTS,
  FETCH_PENDING_CONTRACTS,
  FETCH_MY_PARKS
} from '../../../store/modules/security'
import { USER_REQUEST } from '../../../store/actions/user'
import { mapGetters } from 'vuex'

export default {
  name: 'SecurityAdminDashboard',
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['getToken', 'getProfile']),
    ...mapGetters('security', [
      'isSecurityLoading',
      'getMyCompany',
      'getAdminDashboard',
      'getGuards',
      'getActiveShifts',
      'getPendingContracts',
      'getMyParks'
    ]),
    isLoading() {
      return this.isSecurityLoading
    },
    myCompany() {
      return this.getMyCompany
    },
    dashboard() {
      return this.getAdminDashboard
    },
    guards() {
      return this.getGuards
    },
    activeShifts() {
      return this.getActiveShifts
    },
    totalGuards() {
      if (this.myCompany && this.myCompany.total_active_guards !== undefined) {
        return this.myCompany.total_active_guards
      }
      return this.guards.length
    },
    activeGuards() {
      if (this.myCompany && this.myCompany.guards_on_shift !== undefined) {
        return this.myCompany.guards_on_shift
      }
      return this.guards.filter(g => g.is_active).length
    },
    totalClients() {
      return this.assignedClients.length
    },
    totalShifts() {
      return this.activeShifts.length
    },
    assignedClients() {
      if (this.myCompany && this.myCompany.company_contracts) {
        // Filter only ACTIVE contracts and map to client format
        return this.myCompany.company_contracts
          .filter(contract => contract.status === 'ACTIVE')
          .map(contract => ({
            id: contract.company_id,
            name: contract.company_name,
            status: contract.status,
            status_display: contract.status_display,
            created_at: contract.created_at
          }))
      }
      if (this.myCompany && this.myCompany.contracts) {
        // Fallback for old API response format
        return this.myCompany.contracts
          .filter(contract => contract.status === 'ACTIVE')
          .map(contract => ({
            id: contract.company_id,
            name: contract.company_name,
            status: contract.status,
            status_display: contract.status_display,
            created_at: contract.created_at
          }))
      }
      if (this.myCompany && this.myCompany.client_companies) {
        // Fallback for old API response format
        return this.myCompany.client_companies
      }
      return []
    },
    pendingContractsCount() {
      return this.getPendingContracts ? this.getPendingContracts.length : 0
    },
    myParks() {
      if (this.myCompany && this.myCompany.park_contracts) {
        return this.myCompany.park_contracts
      }
      return this.getMyParks || []
    },
    activeParks() {
      return this.myParks.filter(p => p.status === 'ACTIVE').length
    },
    pendingParks() {
      return this.myParks.filter(p => p.status === 'PENDING').length
    }
  },
  methods: {
    fetchData() {
      const token = this.getToken
      this.$store.dispatch(`security/${FETCH_MY_COMPANY}`, token)
      // this.$store.dispatch(`security/${FETCH_ADMIN_DASHBOARD}`, token)
      this.$store.dispatch(`security/${FETCH_GUARDS}`, token)
      this.$store.dispatch(`security/${FETCH_ACTIVE_SHIFTS}`, token)
      this.$store.dispatch(`security/${FETCH_PENDING_CONTRACTS}`, token)
      this.$store.dispatch(`security/${FETCH_MY_PARKS}`, token)
    },
    validateAndFetch() {
      // Verify user is Security Admin (roll 8)
      if (this.getProfile.roll !== 8) {
        this.$router.push('/')
        return
      }
      this.fetchData()
    }
  },
  mounted() {
    if (!this.$store.getters.isAuthenticated) {
      this.$router.push('/')
      return
    }
    
    // Esperar a que el perfil esté cargado antes de verificar el roll
    if (!this.$store.getters.isProfileLoaded) {
      this.$store.dispatch(USER_REQUEST)
        .then(() => {
          this.validateAndFetch()
        })
        .catch(() => {
          this.$router.push('/')
        })
    } else {
      this.validateAndFetch()
    }
  },
  watch: {
    getProfile: {
      handler() {
        this.validateAndFetch()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}
.mt-3 {
  margin-top: 20px;
}
.mt-4 {
  margin-top: 30px;
}
.mb-0 {
  margin-bottom: 0;
}
.mb-3 {
  margin-bottom: 20px;
}
.pa-2 {
  padding: 16px;
}
.pending-contracts-card {
  background: linear-gradient(135deg, #e65100, #ff6f00) !important;
  border: 2px solid #ffcc02 !important;
  box-shadow: 0 4px 20px rgba(230, 81, 0, 0.55) !important;
}
.pulse-icon {
  animation: pulse 1.4s ease-in-out infinite;
}
@keyframes pulse {
  0%   { transform: scale(1);    opacity: 1; }
  50%  { transform: scale(1.18); opacity: 0.8; }
  100% { transform: scale(1);    opacity: 1; }
}
.pending-parks-card {
  background: linear-gradient(135deg, #7c4dff, #5e35b1) !important;
  box-shadow: 0 4px 20px rgba(124, 77, 255, 0.4) !important;
}
</style>
